<template>
  <vs-card class="cardx">
    <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;" >
      <feather-icon @click="$router.go(-1)" icon="ArrowLeftIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
      <h3>
        {{title}}
      </h3>
    </div>
    <div>
      <vs-row >
        <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Type</label>
          <v-select @input="resetInputError('type')"
                    v-model="form.type" :options="types"
                    :reduce="type => type.value" label="text"
                    name="type"
                    v-validate="'required'"
                    :class="errors.has('type') ? 'danger':''"
          />
          <span v-show="errors.has('type')" class="text-danger">{{ errors.first('type') }}</span>
        </vs-col>
        <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <vs-input
            v-model="form.code"
            @change="resetInputError('code')"
            type="text"
            name="code"
            v-validate="'required'"
            :danger="errors.has('code')"
            :danger-text="errors.has('code')? errors.first('code'):null"
            val-icon-danger="close"
            label="Code"
            placeholder=""
            style="width: 100%;"/>
        </vs-col>
      </vs-row>
      <vs-row >
        <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Discount type</label>
          <v-select @input="resetInputError('discount_type')"
                    name="discount_type"
                    v-validate="'required'"
                    :class="errors.has('discount_type') ? 'danger':''"
                    v-model="form.discount_type" :options="discount_types"
                    :reduce="type => type.value" label="text"  />
          <span v-show="errors.has('discount_type')" class="text-danger">{{ errors.first('discount_type') }}</span>
        </vs-col>
        <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <vs-input
            v-model="form.value"
            @change="resetInputError('value')"
            type="text"
            name="value"
            v-validate="'required'"
            :danger="errors.has('value')"
            :danger-text="errors.has('value')? errors.first('value'):null"
            val-icon-danger="close"
            label="Value"
            placeholder=""
            style="width: 100%;"/>
        </vs-col>
      </vs-row>
      <vs-row >
        <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Use type</label>
          <v-select @input="resetInputError('use_type')"
                    name="use_type"
                    v-validate="'required'"
                    :class="errors.has('use_type') ? 'danger':''"
                    v-model="form.use_type" :options="use_types"
                    :reduce="type => type.value" label="text"  />
          <span v-show="errors.has('use_type')" class="text-danger">{{ errors.first('use_type') }}</span>
        </vs-col>
        <vs-col  v-if="form.use_type !== 'dates'" vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <vs-input
            v-model="form.use_value"
            @change="resetInputError('use_value')"
            type="text"
            name="use_value"
            v-validate="'required'"
            :danger="errors.has('use_value')"
            :danger-text="errors.has('use_value')? errors.first('use_value'):null"
            val-icon-danger="close"
            label="Use value"
            placeholder=""
            style="width: 100%;"/>
        </vs-col>
      </vs-row>
      <vs-row v-if="form.use_type === 'dates'">
        <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Since</label>
          <datepicker placeholder="YYYY-MM-DD" :value="form.since" @input="form.since = fixDate($event)"
                      name="since"
                      v-validate="'required'"
                      :input-class="errors.has('since') ? 'danger':''"
                      format="yyyy-MM-dd"
                     ></datepicker>
          <span v-show="errors.has('since')" class="text-danger">{{ errors.first('since') }}</span>
        </vs-col>
        <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Until</label>
          <datepicker placeholder="YYYY-MM-DD"  :value="form.until" @input="form.until = fixDate($event)"
                      format="yyyy-MM-dd"
                      name="until"
                      v-validate="'required'"
                      :input-class="errors.has('until') ? 'danger':''"
          ></datepicker>
          <span v-show="errors.has('until')" class="text-danger">{{ errors.first('until') }}</span>
        </vs-col>
      </vs-row>
      <vs-row >
        <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <vs-checkbox v-model="form.is_active">Enabled</vs-checkbox>
        </vs-col>

      </vs-row>
      <vs-row>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <vs-button :disabled="edit" color="primary" @click="submit" type="filled">Save</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </vs-card>
</template>
<style>
  input.danger{
    border: solid 1px red!important;
  }
</style>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import Datepicker from 'vuejs-datepicker';
  import {COUPON_TYPES, COUPON_DISCOUNT_TYPES, COUPON_USE_TYPES} from '@/constants/coupons'
  import moment from 'moment'

  export default {
    name :'EditCoupon',
    components : {
      Datepicker
    },
    data(){
      return {
        title : null,
        types : COUPON_TYPES,
        discount_types : COUPON_DISCOUNT_TYPES,
        use_types : COUPON_USE_TYPES,
        form:{
          code : null,
          value : 0,
          type : null,
          discount_type : null,
          use_type : null,
          use_value: 0,
          since : null,
          until : null,
          is_active: true
        },
        errors_form : {
        },
        formRequired : {
          code : true,
          value : true,
          type : true,
          discount_type : true,
          use_type : false,
          use_value: false,
          since : false,
          until : false,
          is_active: false
        },
        formValidation : {},
        onSubmit : false,
        edit : false
      }
    },
    computed: {
      ...mapGetters('users',['userCan'])
    },
    watch :{
      '$route.params.id': function (id) {
        this.initData();
      }
    },
    created() {
      this.resetErrors();
      this.initData();
    },
    methods: {
      ...mapActions('coupons',['getCoupon','storeCoupon','updateCoupons']),
      initData(){
        if(this.$route.params.id){
          this.title = 'Edit coupon';
          this.edit = true;
          this.getCoupon({id: this.$route.params.id})
            .then(data=>{
              this.form = data;
            })
            .catch(error=>{
              if(error){
                if(error.status === 404){
                  this.$router.push({name: 'page-error-404'});
                }
              }
            })
        }else{
          this.title = 'New coupon';
          this.form = {
            code : null,
            value : 0,
            type : null,
            discount_type : null,
            use_type : null,
            use_value: 0,
            since : null,
            until : null,
            is_active: true
          };
        }
      },
      resetInputError(key){
        this.errors_form[key] = null;
        this.formValidation[key] = true;
      },
      resetErrors(){
        this.errors_form = {};
        let formValidation ={};
        for(let key in this.form){
          formValidation[key] = true;
        }
        this.formValidation = formValidation;
      },
      isValid(){
        let errors_form ={};
        let formValidation = _.cloneDeep(this.formValidation);
        for(let key in this.form){
          if(!this.form[key] && this.formRequired[key]){
            errors_form[key] = 'Required';
            formValidation[key] = false;
          }else{
            formValidation[key] = true;
          }
        }
        this.formValidation = formValidation;
        this.errors_form = errors_form;

        return Object.keys(errors_form).length === 0;
      },
      async submit(){
        let result = await this.$validator.validateAll();
        if (!result || this.onSubmit) {
          return;
        }

        if(this.$route.params.id){
          if(!this.userCan('coupons.update')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }
          this.$vs.loading({
            type:'point',
          });
          this.onSubmit = true;
          this.updateCoupons(this.form)
            .then(data=>{
              this.$vs.loading.close();
              this.msgDialog('success','Success','Coupon successfully updated',this.redirectToCoupons);
              this.onSubmit = false;
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error.status === 409 || error.status === 400){
                this.setErrors(error.data.errors);
              }else{
                this.$vs.notify({
                  color: 'danger',
                  title: `Error`,
                  text: "There was an error. Please try again later.",
                });
              }
              //this.msgDialog('danger','Error','Driver successfully updated');
            })
        }else{
          if(!this.userCan('coupons.create')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }
          this.$vs.loading({
            type:'point',
          });
          this.onSubmit = true;
          this.storeCoupon(this.form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Coupon successfully created',this.redirectToCoupons);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error.status === 409 || error.status === 400){
                this.setErrors(error.data.errors);
              }else{
                this.$vs.notify({
                  color: 'danger',
                  title: `Error`,
                  text: "There was an error. Please try again later.",
                });
              }
            })
        }
      },
      msgDialog(color, title, text, action){
        this.$vs.dialog({
          color: color,
          title: title,
          text: text,
          accept:action
        })
      },
      redirectToCoupons(){
        this.$router.push({name: 'coupons List'});
      },
      fixDate(event){
        return moment(event).format('YYYY-MM-DD');
      },
      setErrors(errors){
        for(let key in errors){
          if(Array.isArray(errors[key])){
            this.errors.add({
              field: key,
              msg: errors[key][0]
            });
          }
        }
      },
    }
  }
</script>
